import { bulk as bulkUpdate } from './update';

export function request(sportId) {
    return {
        type: 'GRADES_GET_LIST_REQUEST',
        sportId
    };
}

export function error(sportId, errors) {
    return {
        type: 'GRADES_GET_LIST_ERROR',
        sportId,
        errors
    };
}

export function finish(sportId, grades) {
    return (dispatch) => {
        dispatch(bulkUpdate(grades));

        dispatch({
            type: 'GRADES_GET_LIST_FINISH',
            sportId,
            grades
        });
    };
}
